import type { NotifyLogType, NotifyUiType } from "@rws-framework/client";
import RWSClient, { RWSContainer } from "@rws-framework/client";
import type { RWSClientInstance } from "@rws-framework/client/src/client";

import "./styles/main.rws.scss";

import {
  loadComponentsLazily,
  loadEagerComponents,
} from "./application/_initComponents";
import "./application/_initServices";


async function initializeApp() {
  const theClient: RWSClientInstance = RWSContainer().get(RWSClient);

  theClient.assignClientToBrowser();

  theClient.domService.setHTMLPolicy("junction-policy", (html: string) => {
    return html;
  });

  theClient.setNotifier(
    (
      message: string,
      logType: NotifyLogType = "info",
      uiType: NotifyUiType = "alert",
      onConfirm,
    ) => {
      switch (uiType) {
        case "notification":
          console.info(message);

          if (onConfirm) {
            onConfirm();
          }

          return null;

        case "alert":
          alert(message);

          if (onConfirm) {
            onConfirm();
          }

          return null;
        case "silent":
          if (logType == "warning") {
            console.warn(message);
          } else if (logType == "error") {
            console.error(message);
          } else {
            console.log(message);
          }
          return;
      }
    },
  );


  loadEagerComponents();
  loadComponentsLazily();
}

initializeApp();
